export default "__VITE_ASSET__BFwCtF$u__"